
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.45.01c-1.548 0-2.847 1.084-3.2 2.53H.78a.771.771 0 00-.771.77.771.771 0 00.77.771h2.314v11.091A2.839 2.839 0 005.92 18h6.168a2.839 2.839 0 002.827-2.827V4.082h2.313a.771.771 0 00.77-.772.771.771 0 00-.77-.77h-4.472C12.405 1.094 11.106.01 9.558.01zm0 1.541h1.108c.677 0 1.147.435 1.442.988H7.008c.295-.553.764-.988 1.442-.988zm-3.815 2.53h8.738v11.091c0 .72-.566 1.285-1.285 1.285H5.92a1.273 1.273 0 01-1.285-1.285z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    